export default __webpack_public_path__ + "static/media/pulse_video.109c22e0.svg";